<template>
  <van-nav-bar @click-left="onClickLeft" :title="titleTex">
    <template #left>
      <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../assets/'+appTheme+'/right_icon2.png')" alt="">
    </template>
<!--        <template #right>-->
<!--          <img style="width: 4.93333vw;height: auto;display: inline-block;" src="../assets/car_icon.png" alt="">-->
<!--        </template>-->
  </van-nav-bar>
</template>

<script>
export default {
name: "navBar",
  props:['titleTex'],
  data(){
    return {
      appTheme:this.$store.state.appTheme,
    }
  },
  methods: {
    onClickLeft() {
      if (window.history.length <= 1) {
        this.$router.push('/');
        return false
      } else {
        this.$router.go(-1);
      }
    },
    onClickRight() {
      this.$router.push({path:'/cart'})
    },
  }
}
</script>

<style lang="scss" scoped>
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
</style>
